module.exports = __webpack_public_path__ + "img/IMG_6419 1.cb36e29d.webp";